/* eslint-disable */
import CompanyDetailsDialogContainer from './company-details-dialog.container';

export default CompanyDetailsDialogContainer; 